import React, { useState, useEffect } from "react";
import { Row, Col, Form, Spinner, Modal, Button } from "react-bootstrap";
import { FaEye } from "react-icons/fa";
import "../../Styles/yellowcalf.css/Failed_Transactions.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import { useNavigate } from "react-router-dom";
import ScaleLoader from "react-spinners/ScaleLoader";
import { formatNumber } from "../../utils/formatNumber";

function ParentTransactionReceipt() {
  const [transactionList, setTransactionList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [idSearch, setIdSearch] = useState("");
  const [selectedInvoices, setSelectedInvoices] = useState([]);


  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;


  const [selectedTransactionId, setSelectedTransactionId] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);
const [totalPages, setTotalPages] = useState(1); 
  const navigate = useNavigate();
  const customer_currency = (localStorage.getItem("customer_currency") || "").replace(/"/g, "");

  // Toggle single checkbox
const handleRowCheck = (feeInvoiceId) => {
  setSelectedInvoices((prev) =>
    prev.includes(feeInvoiceId)
      ? prev.filter((id) => id !== feeInvoiceId)
      : [...prev, feeInvoiceId]
  );
};

// Header "Check All"
const handleCheckAll = (checked) => {
  if (checked) {
    const allIds = transactionList.map(
      (item) => item.fee_invoice_id
    );
    setSelectedInvoices(allIds);
  } else {
    setSelectedInvoices([]);
  }
};

useEffect(() => {
  const handler = setTimeout(() => {
    fetchFailedTransactions();
  }, 500);

  return () => {
    clearTimeout(handler);
  };
}, [currentPage, idSearch, searchTerm]);

  const fetchFailedTransactions = async () => {
    setIsLoading(true);
    try {
      const payload = {
        customer_id: Number(localStorage.getItem("customer_id")) || 1005,
        api_key:
          localStorage.getItem("api_key") ||
          "b9359f494e77b6589ce12dd62518c585",
        language: "en",
        status: "success",
        page: currentPage,
      };
      if(idSearch) {
        payload.parent_transactions_id  = idSearch
      }
      if(searchTerm) {
        payload.student_name  = searchTerm
      }

      const response = await simplePostCall(
        ApiConfig.parentfailedtransaction,
        JSON.stringify(payload)
      );

      if (response?.result) {
        setTransactionList(response.searchModel || []);
        setTotalPages(response?.total_pages)
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };




  return (
    <div className="customer-container">
      {/* HEADER */}
      <div className="special-header panel-white-all">
        <h4 className="page-title">Parent Successful Transactions</h4>
        <Button className="btn btn-primary">Print All</Button>
      </div>

      <div className="yc-list-body">
        {/* FILTER BAR */}
        <div className="yc-list-filter">
          <Form.Control
            placeholder="Student Name"
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setCurrentPage(1);
            }}
          />

          <Form.Control
            placeholder="Transaction Id"
            value={idSearch}
            onChange={(e) => {
              setIdSearch(e.target.value);
              setCurrentPage(1);
            }}
          />

          <Button
            className="btn btn-primary"
            onClick={() => {
              setSearchTerm("");
              setIdSearch("");
              setCurrentPage(1);
            }}
          >
            Clear
          </Button>
        </div>

        {/* Column Header */}
        <div className="yc-list-thead-card">
          <div className="yc-list-grid yc-list-grid-9">
            <div className="yc-list-cell">
              <Form.Check
                checked={transactionList.length > 0 && selectedInvoices.length === transactionList.length}
                onChange={(e) => handleCheckAll(e.target.checked)}
              />
            </div>
            <div className="yc-list-cell">Paid By User</div>
            <div className="yc-list-cell">Student Name</div>
            <div className="yc-list-cell">Grade</div>
            <div className="yc-list-cell">Division</div>
            <div className="yc-list-cell">Transaction Id</div>
            <div className="yc-list-cell">Amount</div>
            <div className="yc-list-cell">Mode</div>
            <div className="yc-list-cell">Actions</div>
          </div>
        </div>

        {/* Rows */}
        {isLoading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: "20vh" }}>
            <ScaleLoader color="#F4BB44" />
          </div>
        ) : transactionList?.length > 0 ? (
          <div className="yc-list-row-list">
            {transactionList.map((item) => (
              <div key={item.parent_transactions_id} className="yc-list-row-card">
                <div className="yc-list-grid yc-list-grid-9">
                  <div className="yc-list-cell">
                    <Form.Check
                      checked={selectedInvoices.includes(item.fee_invoice_id)}
                      onChange={() => handleRowCheck(item.fee_invoice_id)}
                    />
                  </div>
                  <div className="yc-list-cell">{item.student_father_name}</div>
                  <div className="yc-list-cell fw-bold">{item.student_name}</div>
                  <div className="yc-list-cell">{item.student_class}</div>
                  <div className="yc-list-cell">{item.division || "-"}</div>
                  <div className="yc-list-cell">{item.parent_transactions_id}</div>
                  <div className="yc-list-cell">{customer_currency} {formatNumber(item.transaction_amount)}</div>
                  <div className="yc-list-cell">{item.transaction_mode}</div>
                  <div className="yc-list-cell yc-list-cell-actions">
                    <button
                      className="yc-action-icon"
                      title="View"
                      onClick={() => navigate(`/accountant/parenttransactions/view/${item.parent_transactions_id}`)}
                    >
                      <FaEye />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="yc-empty-state">No records found</div>
        )}

      {/* PAGINATION */}
      <div className="d-flex justify-content-end align-items-center mt-3 gap-2">
        <Button
          className="btn btn-primary btn-sm"
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((p) => p - 1)}
        >
          Prev
        </Button>

        <span className="text-muted">
          Page {currentPage} of {totalPages || 1}
        </span>

        <Button
          className="btn btn-primary btn-sm"
          disabled={currentPage === totalPages || totalPages === 0}
          onClick={() => setCurrentPage((p) => p + 1)}
        >
          Next
        </Button>
      </div>
      </div>
    </div>
  );
}

export default ParentTransactionReceipt;
